import { WhyZafara } from "@/components/landing/WhyZafara";
import { PageFooterNav } from "@/components/landing/PageChrome";
import { SEO } from "@/components/SEO";

export default function PageWhy() {
  return (
    <>
      <SEO
        title="Pourquoi Zafara"
        description="L'histoire du nom Zafara — ZA / FAR / A. La marketplace béninoise conçue pour se décliner partout en Afrique de l'Ouest."
        path="/pourquoi-zafara"
      />
      <WhyZafara />
      <PageFooterNav
        prev={{ to: "/", label: "Accueil" }}
        next={{ to: "/application", label: "L'application" }}
      />
    </>
  );
}
